import { AccessForbiddenPage } from '@openx/components-core/lib/AccessForbiddenBackPage/AccessForbiddenPage';
import { HeaderActions } from '@openx/components-header/HeaderActions/HeaderActions';
import { PageHeader } from '@openx/components-header/PageHeader';
import { Feature_Flags_Enum } from '@openx/types/gqlTypes';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../../components/AuthContext/context';
import { isMasterOrganisation } from '../../permissions/validators';
import { useFeatureFlag } from '../featureFlags/useFeatureFlag';
import { CuratedDealBuyerDiscountsList } from './List/CuratedDealBuyerDiscountsList';

export const CuratedDealBuyerDiscountsPage = () => {
  const { session } = useAuth();
  const hasCuratedDealBuyerDiscountFeature = useFeatureFlag(Feature_Flags_Enum.CuratedDealBuyerDiscount);
  const { t } = useTranslation();

  const isMasterOrg = isMasterOrganisation(session);

  const renderActions = useCallback(() => {
    if (isMasterOrg) {
      return undefined;
    }

    return (
      <HeaderActions
        actions={[
          {
            color: 'primary',
            'data-test': 'create-discount-button',
            href: '/discounts/create',
            label: t('Create new Discount'),
            showAsActionButton: true,
          },
        ]}
      />
    );
  }, [isMasterOrg, t]);

  if (!hasCuratedDealBuyerDiscountFeature && !isMasterOrg) {
    return <AccessForbiddenPage />;
  }

  return (
    <PageHeader render={renderActions} titlePrefix="OpenXSelect" title={t('Discounts')}>
      <CuratedDealBuyerDiscountsList />
    </PageHeader>
  );
};
